import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, ReportIdSchema, RevisionIdSchema, RunIdSchema, } from "../primitives/ids.js";
import { ReportLifecycleStatusSchema, ReportTypeSchema } from "./report-lifecycle.js";
/** Persisted Step 8 handoff compatibility envelope (Step 7 stores only; Step 8 not implemented). */
export const ReportStep8HandoffMetadataV1Schema = z
    .object({
    schemaVersion: z.literal("report-step8-handoff-metadata.v1.0"),
    reportId: ReportIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    businessGraphRevisionId: RevisionIdSchema,
    snapshotHash: z.string().min(1),
    artifactSetHash: z.string().min(1),
    qualityGateResultRef: z.string().min(1),
    reportType: ReportTypeSchema,
    reportVariant: z.enum(["INTERNAL", "CLIENT_SAFE"]),
    lifecycleStatus: ReportLifecycleStatusSchema,
    clientSafe: z.boolean(),
    storageArtifactUri: z.string().min(1),
    traceId: z.string().min(1),
    correlationId: z.string().min(1).optional(),
    runId: RunIdSchema,
})
    .strict();
//# sourceMappingURL=report-step8-handoff-metadata.js.map